import { isServer, isDevelopment } from '@/utils/helpers';

export const logFacebookAnalytic = (code) => {
  if (isServer || isDevelopment) {
    return;
  }

  let c = code;
  let action = 'trackCustom';

  if (c === 'registration') {
    c = 'CompleteRegistration';
    action = 'track';
  }

  window.fbq(action, code);
};
